export const widgetKinds = [
  "clock",
  "weather",
  "app",
  "iframe",
  "video",
  "notebook",
  "anchorNote",
  "dnsHoleSummary",
  "dnsHoleControls",
  "smartHome-entityState",
  "smartHome-executeAutomation",
  "stockPrice",
  "mediaServer",
  "calendar",
  "downloads",
  "mediaRequests-requestList",
  "mediaRequests-requestStats",
  "mediaTranscoding",
  "minecraftServerStatus",
  "networkControllerSummary",
  "networkControllerStatus",
  "rssFeed",
  "bookmarks",
  "indexerManager",
  "healthMonitoring",
  "releases",
  "mediaReleases",
  "dockerContainers",
  "firewall",
  "notifications",
  "systemResources",
  "coolify",
  "systemDisks",
  "timetable",
  "immich-serverStats",
  "immich-albumCarousel",
  "paperlessNgx",
  "tracearr",
  "speedtestTracker",
  "uptimeKuma",
  "audioStats",
  "umami",
  "vpn",
  "archiveTeamWarrior",
  "ups",
  "beszelSystemTable",
  "beszelSystemGrid",
  "beszelAlerts",
  "beszelSystemStats",
  "customApi",
] as const;
export type WidgetKind = (typeof widgetKinds)[number];

export const widgetDefaultSizes: Partial<Record<WidgetKind, { width: number; height: number }>> = {
  uptimeKuma: { width: 2, height: 3 },
  audioStats: { width: 2, height: 2 },
  paperlessNgx: { width: 2, height: 2 },
};
